import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const SessionTimeout = React.lazy(() => import("./SessionTimeout"));

function SessionTimeoutWrapper(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "pages.sessionTimeout.pageTitle",
      defaultValue: "Smart Portal - Session Timeout",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "common.loading", defaultValue: "Loading" })}
        />
      }
    >
      <SessionTimeout {...props} />
    </Suspense>
  );
}

export default SessionTimeoutWrapper;
